module.exports = __webpack_public_path__ + "img/np_realtime_591026_000000.e8a8aa63.svg";